var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"app",class:{ 'no-bg-image': _vm.backgroundType === 'blank', 'onboarding-guide': _vm.backgroundType == 'onboarding_guide'},attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }